import { DefaultSessionService } from '@/application/session/DefaultSessionService'
import { AppConfig } from '@/config/AppConfig'
import { ApiClient } from '@/infrastructure/http/ApiClient'
import type { Fetcher } from '@/infrastructure/http/HttpClient.types'
import {
  AuthInterceptor,
  BusinessResponseProcessor,
  HeaderInterceptor,
} from '@/infrastructure/http/StandardHttpPipeline'
import { createDIContainer } from './DIContext'

export function createDefaultDIContainer(fetcher: Fetcher) {
  const sessionService = new DefaultSessionService(window.localStorage)
  const apiClient = new ApiClient(
    AppConfig.ApiDomain,
    fetcher,
    [
      new HeaderInterceptor({
        'app-id': 'laiwan',
        'content-type': 'application/json',
        'accept-language': 'en-US',
        'app-version': AppConfig.Version,
      }),
      new AuthInterceptor(window.localStorage, 'access_token'),
    ],
    new BusinessResponseProcessor(() => {
      sessionService.clearSession()
      if (window.location.pathname !== '/login') {
        window.location.replace('/login')
      }
    }),
  )

  return createDIContainer({
    httpClient: apiClient,
    storage: window.localStorage,
  })
}
